import { secondaryFontFamily } from '@openeducation/oe-rn-themes';
import React from 'react';

import { OEText, OETextProps } from '../oe-text/oe-text';

export interface InterTextProps extends Omit<OETextProps, 'fontFamily'> {}

export const InterText = ({ children, ...props }: InterTextProps) => {
  return (
    <OEText fontFamily={secondaryFontFamily} {...props}>
      {children}
    </OEText>
  );
};
